import memoize from 'memoize-one'

import { useRulesQuery } from '@/graphql/generated/hooks'
import { OrderDirection, RuleOrderField } from '@/graphql/generated/schemas'

export const ROW_HEIGHT = 40
export const createItemData = memoize(
  (items, prepareRow, handleToggleSwitch, handleOnRemove, onRowClick) => ({
    items,
    prepareRow,
    handleToggleSwitch,
    handleOnRemove,
    onRowClick,
  })
)

const orderByMapping = {
  ruleName: RuleOrderField.Name,
  createdAt: RuleOrderField.CreatedAt,
}

export type RulesListType = ReturnType<
  typeof useRulesQuery
>['data']['rules']['edges']

export type RulesType = ReturnType<
  typeof useRulesQuery
>['data']['rules']['edges']['0']['node']

export type RulesRefetchType = ReturnType<typeof useRulesQuery>['refetch']

export const getOrderBy = (sortedColumn: {
  id?: string
  isSortedDesc?: boolean
}): {
  direction: OrderDirection
  field: RuleOrderField
}[] => {
  if (!sortedColumn?.id) {
    // Apply default sorting by date
    return [
      {
        direction: OrderDirection.Desc,
        field: RuleOrderField.CreatedAt,
      },
    ]
  } else {
    const direction = sortedColumn.isSortedDesc
      ? OrderDirection.Desc
      : OrderDirection.Asc
    const field = orderByMapping[sortedColumn.id]
    return [
      {
        direction,
        field,
      },
    ]
  }
}
